'use client';

import React from 'react';
import { Map } from '@/widgets/Map';
import { useRouter } from '@/navigation';
import type { IMedcenterDetails } from '@/entities/medcenter/model/types';
interface Props {
  medcenter: IMedcenterDetails;
  city: string;
  fullMap: boolean;
}
export const MedcenterMap: React.FC<Props> = ({
  medcenter,
  fullMap,
  city
}) => {
  const router = useRouter();
  const showFullMap = () => {
    router.push({
      pathname: `/${city}/medcenter/${medcenter.alias}`,
      query: {
        fullMap: true
      }
    });
  };
  return <Map geo={medcenter.geo} showFullMap={showFullMap} visibleFullMap={fullMap} data-sentry-element="Map" data-sentry-component="MedcenterMap" data-sentry-source-file="MedcenterMap.tsx" />;
};